module.exports = __webpack_public_path__ + "static/media/heart.d37f1ceb.svg";